import { KeyboardEvent, useEffect, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";

import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4, validateString } from "src/utils/string/stringUtil";
import { useMST1110_R01Store } from "./Store_MST1110_R01";
import { SysCodeDto } from "src/types/base";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const MST1110_R01SearchSection = ({ onEnterKeyDown }: Props) => {

	const { MST1110_R01Filter, setMST1110_R01Filter } = useMST1110_R01Store();
	const { compCdList, yesNoList, wmsCdList, warehouseCdList } = useCommonCodeStore();

	useEffect(() => {
		setMST1110_R01Filter({ ...MST1110_R01Filter,
			warehouseCd: ''
		});
		if(!validateString(MST1110_R01Filter.logicCenter)) {
			setMST1110_R01Filter({ ...MST1110_R01Filter, logicCenter: wmsCdList[0].minorCd });
		}
	}, [MST1110_R01Filter.logicCenter]);

  return (
    <SearchSectionForm>
		{/* MST1110_R01Filter : {JSON.stringify(MST1110_R01Filter)} */}
		
		<SearchDropDownForm<SysCodeDto>
                    label="물류센터"
                    value={MST1110_R01Filter.logicCenter}
                    optionList={wmsCdList}
					initLabelLess={true}
                    onChangeValue={v => setMST1110_R01Filter({ logicCenter: v === 'all' ? '' : v })}
                />
        <SearchDropDownForm<WareHouseDto>
                    label="창고코드"
                    value={MST1110_R01Filter.warehouseCd}
                    optionList={warehouseCdList.filter(item => item.logicCenter === MST1110_R01Filter.logicCenter)}
                    onChangeValue={v => setMST1110_R01Filter({ warehouseCd: v === 'all' ? '' : v })}
                />

		{/* MST1110_R01Filter : {JSON.stringify(MST1110_R01Filter)} <br/> */}
	</SearchSectionForm>
  );
};